import "jquery";
import "jquery-ui";
// import "popper";
import "bootstrap";
import "@fortawesome/fontawesome-free";

import "./rails-links";
import "./turbo"
import "./controllers/index";
import "./utils/index";

$(".btn-toggle").on("click", function (e) {
  var aim = $(e.target).attr("data-target");
  $(aim).slideToggle("slow");
});
